/**
 * File.
 *
 * @author Igor Zaporozhets <deadbyelpy@gmail.com>
 * @license GNU GENERAL PUBLIC LICENSE Version 3
 */

'use strict';

var async   = require('cjs-async'),

    config        = require('../tools/config'),
    taskManager   = require('./task.manager'),
    platformEvent = require('./platform.event'),

    splash = require('../../components/splash'),

    loaders = [],
    iterator = 0,
    loadCss = true,

    appConfig, size,

    ignoreDone = false;


if ( DEVELOP ) {
    window.launcherReady = false;
}


/* eslint max-lines-per-function: ['error', {max: 200, skipBlankLines: true, skipComments: true}] */
function showStartApplication ( app ) {
    var $link, height;


    // window.top.console.log('showStartApplication + ' + app.config.url);
    if ( loadCss ) {
        $link = document.createElement('link');
        height = window.innerHeight || window.screen.height;

        // remove this code, after magcore-osd-base refactoring
        switch ( height ) {
            case 480:
            case 576:
            case 720:
            case 1080:
                break;

            default:
                height = 720;
                break;
        }
    }

    if ( app.core.ready ) {
        // window.top.console.log('app already ready');
        if ( DEVELOP ) {
            debug('system')('all loaded');
            debug('system')(app.config.name  + ' ready');
        }

        // window.top.console.log(app === taskManager.launcher + ' app is launcher?');
        // window.top.console.log(taskManager.home + ' taskManager.home?');
        if ( app === taskManager.launcher && taskManager.home ) {
            showStartApplication(taskManager.home);

            return;
        }

        // window.top.console.log('no return');

        if ( NANOCORE ) {
            splash.hide();
        }

        // window.top.console.log('locked? ' + app.config.locked);
        if ( app.config.locked ) {
            if ( window.core.accessControl ) {
                window.core.accessControl.request(function ( error ) {
                    if ( DEVELOP ) {
                        debug('iframe')('access control request error: ' + error);
                    }
                    if ( error ) {
                        splash.init();
                        taskManager.show(taskManager.launcher);
                    } else {
                        splash.init();
                        taskManager.show(app);
                    }
                });
            } else {
                splash.init();
                taskManager.show(app);
            }
        } else {
            // window.top.console.log('splash init');
            splash.init();
            // window.top.console.log(' show called');
            taskManager.show(app);
        }
        taskManager.daemons.forEach(function ( daemon ) {
            if ( DEVELOP ) {
                try {
                    setTimeout(function () {
                        var date = Date.now();

                        daemon.emit('launcher:ready');
                        debug('plugin')('time to call launcher:ready ' + (Date.now() - date));
                    }, 0);
                } catch ( error ) {
                    debug('system')('emit launcher:ready error: ' + error);
                }
            } else {
                setTimeout(function () {
                    daemon.emit('launcher:ready');
                }, 0);
            }
        });

        if ( loadCss ) {
            $link.rel  = 'stylesheet';
            $link.href = window.core.theme.path + height + '.css';
            document.head.appendChild($link);
        }

        if ( DEVELOP ) {
            debug('kernel')('loading time: ' + (Date.now() - window.st));
        }
    } else {
        if ( DEVELOP ) {
            debug('system')('all loaded');
        }

        // window.top.console.log('app wait for ready');
        app.core.once('app:ready', function () {
            // window.top.console.log('app now ready');
            if  ( DEVELOP ) {
                debug('system')(app.config.name  + ' ready');
            }

            if ( app === taskManager.launcher && taskManager.home ) {
                showStartApplication(taskManager.home);

                return;
            }

            if ( NANOCORE ) {
                splash.hide();
            }

            if ( app.config.locked ) {
                if ( window.core.accessControl ) {
                    window.core.accessControl.request(function ( error ) {
                        if ( DEVELOP ) {
                            debug('iframe')('access control request error: ' + error);
                        }
                        if ( error ) {
                            splash.init();
                            taskManager.show(taskManager.launcher);
                        } else {
                            splash.init();
                            taskManager.show(app);
                        }
                    });
                } else {
                    splash.init();
                    taskManager.show(app);
                }
            } else {
                splash.init();
                taskManager.show(app);
            }
            taskManager.daemons.forEach(function ( daemon ) {
                if ( DEVELOP ) {
                    try {
                        daemon.emit('launcher:ready');
                    } catch ( error ) {
                        debug('system')('emit launcher:ready error: ' + error);
                    }
                } else {
                    daemon.emit('launcher:ready');
                }
            });

            if ( loadCss ) {
                $link.rel  = 'stylesheet';
                $link.href = window.core.theme.path + height + '.css';
                document.head.appendChild($link);
            }

            if ( DEVELOP ) {
                debug('kernel')('loading time: ' + (Date.now() - window.st));
            }
        });
    }
}


if ( DEVELOP ) {
    debug('system')('init');
}
size  = config.data.apps.length;

/* eslint no-loop-func: 0 */
while ( iterator < size ) {
    appConfig = config.data.apps[iterator];

    if ( appConfig.type === 'auth' ) {
        loadCss = false;
        ++iterator;
        /* eslint no-continue: 0 */
        continue;
    }

    switch ( appConfig.type ) {
        case 'launcher':
            (function ( index ) {
                if ( taskManager.launchers.length > 0 ) {
                    core.notify({
                        title: 'Attention you have 2 launchers in config!!!!',
                        icon: 'warning'
                    });
                } else {
                    loaders.push(function ( done ) {
                        setTimeout(function () {
                            taskManager.launcher = taskManager.runApp({
                                config: config.data.apps[index],
                                visible: false,
                                onload: function () {
                                    setTimeout(function () {
                                        if ( DEVELOP ) {
                                            debug('system')(config.data.apps[index].name + ' DONE');
                                        }
                                        if ( !ignoreDone ) {
                                            done(false, taskManager.launcher);
                                        }
                                    }, 0);
                                },
                                onerror: function ( url ) {
                                    if ( DEVELOP ) {
                                        debug('system')('launcher loading error, url:' + url);
                                    }
                                }
                            });
                        }, 0);
                    });
                }
                taskManager.launchers.push(config.data.apps[index]);

            })(iterator);
            break;

        case 'system':
            (function ( index ) {
                // setTimeout(function () {
                //     taskManager.runApp({
                //         config: config.data.apps[index],
                //         visible: false
                //     });
                // }, 0);

                loaders.push(function ( done ) {
                    setTimeout(function () {
                        var app = taskManager.runApp({
                            config: config.data.apps[index],
                            visible: false,
                            onready: function () {
                                setTimeout(function () {
                                    if ( DEVELOP ) {
                                        debug('system')(config.data.apps[index].name + ' DONE');
                                    }
                                    if ( !ignoreDone ) {
                                        done(false, app);
                                    }
                                }, 0);
                            },
                            onerror: function ( url ) {
                                if ( DEVELOP ) {
                                    debug('system')('launcher loading error, url:' + url);
                                }
                            }
                        });
                    }, 0);
                });
            })(iterator);
            break;

        case 'osd':
            (function ( index ) {
                setTimeout(function () {
                    taskManager.runApp({
                        config: config.data.apps[index],
                        visible: false
                    });
                }, 0);
            })(iterator);
            break;

            // case 'app':
            //     if ( config.data.apps[iterator].home ) {
            //         (function ( index ) {
            //             loaders.push(function ( done ) {
            //                 setTimeout(function () {
            //                     taskManager.home = taskManager.runApp({
            //                         config: config.data.apps[index],
            //                         visible: false,
            //                         onload: function () {
            //                             done(false, taskManager.home);
            //                         },
            //                         onerror: function ( url ) {
            //                             if ( DEVELOP ) {
            //                                 debug('system')('launcher loading error, url:' + url);
            //                             }
            //                         }
            //                     });
            //                 }, 0);
            //             });
            //         })(iterator);
            //     }
            //     break;

        default:
            break;
    }

    ++iterator;
}

if ( taskManager.homeConfig ) {
    loaders.push(function ( done ) {
        // confirm(JSON.stringify(taskManager.homeConfig));
        setTimeout(function () {
            taskManager.home  = taskManager.runApp({
                config: taskManager.homeConfig,
                visible: false,
                onready: function () {
                    if ( DEVELOP ) {
                        debug('system')('home app ready');
                    }
                    // confirm(111)
                    setTimeout(function () {
                        if ( !ignoreDone ) {
                            done(null, taskManager.home);
                        }
                    }, 0);
                }
            });
        }, 0);
    });
}

// loaders.push(taskManager.init());

async.parallel(loaders, function () {
    if ( platformEvent.load ) {
        platformEvent.load();
    }

    ignoreDone = true;

    if ( taskManager.home ) {
        showStartApplication(taskManager.home);
    } else if ( taskManager.launcher ) {
        showStartApplication(taskManager.launcher);
    } else {
        /* eslint no-useless-escape: 0 */
        document.body.innerHTML = '';
        document.body.style.backgroundColor = '#1B5E20 !important';
        document.body.style.overflow = 'scroll';
        document.body.appendChild(document.createElement('pre'));
        document.body.firstChild.tabIndex = 1;
        document.body.firstChild.style.cssText = 'overflow-y: scroll; height: ' +
            window.innerHeight || window.screen.height + 'px; width: ' +
            window.innerWidth || screen.width + 'px;font-family: monospace;' +
            'font-size: 26px; text-align: left;padding: 20px;color: #f0f0f0;"';
        document.body.firstChild.innerText = '\Launcher not found in config: Fatal Exception';
        document.body.firstChild.focus();
    }
});
